<template>
  <div class="home">
    <tabbar :teamRemark="teamRemark" :canOrder="canOrder"></tabbar>
    <div class="content">
      <div class="column"
           ref="viewBox">
        <div class="wrapper">
          <span class="title">开馆时间</span>
          <span class="time">{{ openingTime }}</span>
          <span class="details">{{ openingTimeRemarks }}</span>
        </div>
      </div>
      <div class="column">
        <div class="wrapper">
          <span class="title">预约须知</span>
          <span class="notice">{{ bookingInfo }}</span>
          <template v-if="isHidden1">
            <div class="hideBg">
              <span class="details">{{ bookingInfoRemarks }}</span>
            </div>
            <!-- <span class="show" @click.stop.prevent="onShow1" v-show="false">展开</span> -->
          </template>
          <template v-else>
            <!-- 显示完整内容的画面 -->
            <div class="showBg">
              <span class="details">{{ bookingInfoRemarks }}</span>
            </div>
            <!-- 绑定点击事件onHide，点击收起内容 -->
            <!-- <span class="show" @click.stop.prevent="onHide1">收起</span> -->
          </template>
        </div>
      </div>
      <div class="column">
        <div class="wrapper">
          <span class="title">领票须知</span>
          <span class="notice">{{ ticketInfo }}</span>
          <template v-if="isHidden2">
            <div class="hideBg">
              <span class="details">{{ ticketInfoRemarks }}</span>
            </div>
            <!-- <span class="show" @click.stop.prevent="onShow2" v-show="false">展开</span> -->
          </template>
          <template v-else>
            <!-- 显示完整内容的画面 -->
            <div class="showBg">
              <span class="details">{{ ticketInfoRemarks }}</span>
            </div>
            <!-- 绑定点击事件onHide，点击收起内容 -->
            <!-- <span class="show" @click.stop.prevent="onHide2">收起</span> -->
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabbar from "@/components/tabBar/tabBar";

export default {
  name: "home",
  components: { tabbar },
  data () {
    return {
      isHidden1: false,
      isHidden2: false,
      ispersonal: "",
      openingTime: "",
      openingTimeRemarks: "",
      bookingInfo: "",
      bookingInfoRemarks: "",
      ticketInfo: "",
      ticketInfoRemarks: "",
      issmsCode: "", //是否开启验证码
      // noToken:'',//
      isToken: true, //url中是否有token
      canOrder: true, //是否开启团队预约
      teamRemark: "", //后台提示
    };
  },
  methods: {
    //获取地址栏参数
    getQueryStringRegExp: function getQueryStringRegExp (name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    onShow1 () {
      this.isHidden1 = false; //点击onShow切换为false，显示为展开画面
    },
    onHide1 () {
      this.isHidden1 = true; //点击onHide切换为true，显示为折叠画面
    },
    onShow2 () {
      this.isHidden2 = false; //点击onShow切换为false，显示为展开画面
    },
    onHide2 () {
      this.isHidden2 = true; //点击onHide切换为true，显示为折叠画面
    },

    getmuseumInfo () {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
          "/api/order/web/ticket/detail?museumCode=" +
          this.$store.state.museumCode,
          {}
        )
        .then(response => {
          var result = response.data;
          // this.banner.backgroundImage =
          //   "url" +
          //   "(" +
          //   window.SITE_CONFIG.baseUrl +
          //   "/api/order/web/images/" +
          //   result.data.image1 +
          //   ")";
          this.issmsCode = result.data.messageFlag;
          this.openingTime =
            result.data.openingStartTime + "~" + result.data.openingEndTime;
          this.openingTimeRemarks = result.data.openingTimeRemarks;
          this.bookingInfo = result.data.bookingInfo;
          this.bookingInfoRemarks = result.data.bookingInfoRemarks;
          this.ticketInfo = result.data.ticketInfo;
          this.ticketInfoRemarks = result.data.ticketInfoRemarks;
          this.canOrder = result.data.teamFlag;
          this.teamRemark = result.data.teamRemark;
        });
    },
    //整页加载
    openFullScreen () {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    }
  },
  mounted () {
    // this.openFullScreen();
    this.$nextTick(() => {
      this.getQueryStringRegExp("token");
      this.getQueryStringRegExp("museumCode");
      //如果获取到小程序传来的token
      if (this.getQueryStringRegExp("token") !== "") {
        this.$store.state.token = this.getQueryStringRegExp("token");
        document.cookie = "code" + "=" + this.getQueryStringRegExp("token");
        this.isToken = false;
      } else {
        this.isToken = true;
      }
      console.log(this.getQueryStringRegExp("token"));
      console.log(this.getQueryStringRegExp("museumCode"));
      //判断是否由场馆列表页转入
      if (this.getQueryStringRegExp("museumCode") !== "") {
        this.$store.commit('changeMuseumCode', this.getQueryStringRegExp("museumCode"))
        // sessionStorage.setItem("museumCode", this.getQueryStringRegExp("museumCode"));
        console.log(this.$store.state.museumCode)
      }
      console.log(sessionStorage.getItem('museumCode'));
      this.getmuseumInfo();
    });

    let bg = document.querySelector("#app");
    bg.className = "background";
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/home.vue